/**
 * LocalStorage Reducer Helpers
 */

import { getTimestamp } from '../../utils/date';
import { decodeFromUrl, encodeForUrl } from '../../utils/url';

import { extend, isArray, isObject, template } from 'lodash';
import * as uuid from 'uuid-js';

export const localStorageSuffixSessionTerms = 'sessionTerms';
export const localStorageSuffixCart = 'cart';
export const localStorageSuffixCheckout = 'checkout';
export const localStorageSuffixPreferences = 'prefs';
export const localStorageKeySeparator = ':';
export const localStoragePrefix = 'ams';
const localStorageSessionPrefix = `${localStoragePrefix}${localStorageKeySeparator}session`;

// tslint:disable-next-line:no-invalid-template-strings
// tslint:disable-next-line:max-line-length
const uniqueKeyTemplate = template(`<%= prefix %>${localStorageKeySeparator}<%= uniqueId %>${localStorageKeySeparator}<%= suffix %>`);

export function getLocalStorageKeys(suffix?: string) {
  return Object.keys(localStorage).filter((key) => {
    if (suffix) {
      const regex = new RegExp(`${suffix}$`);
      return key.match(regex);
    }

    return true;
  });
}

export function removeAllSessionItems() {
  const keys = Object.keys(localStorage).filter((key) => {
    const regexp = new RegExp(`^${localStorageSessionPrefix}`);
    return key.match(regexp);
  });

  keys.forEach((key) => {
    localStorage.removeItem(key);
  });
}

export function updateStoredItem(key: string, value: any, merge?: boolean) {
  const timestamp = getTimestamp();
  const storedItemKey = getLocalStorageKeys(key);
  if (storedItemKey.length > 0) {
    const storedItem: ILocalStorageItem = decodeFromUrl(localStorage.getItem(storedItemKey[0])!);
    if (merge) {
      if (isArray(storedItem.data)) {
        storedItem.data.push(value);
      } else if (isObject(storedItem.data)) {
        storedItem.data = extend(storedItem.data, value);
      }
    } else {
      storedItem.data = value;
    }
    storedItem.updatedAt = timestamp;
    localStorage.setItem(storedItemKey[0], encodeForUrl(storedItem));
  } else {
    createItem(key, value);
  }
}

export function createItem(key: string, value: any) {
  const timestamp = getTimestamp();
  const storageItem: ILocalStorageItem = {
    data: value,
    createdAt: timestamp,
    updatedAt: timestamp,
  };

  const uniqueKey = uniqueKeyTemplate({
    prefix: localStorageSessionPrefix,
    uniqueId: uuid.create().toString(),
    suffix: key,
  });

  localStorage.setItem(uniqueKey, encodeForUrl(storageItem));
}

export function removeItem(key: string) {
  const storedItemKey = getLocalStorageKeys(key);
  if (storedItemKey.length > 0) {
    localStorage.removeItem(storedItemKey[0]);
    return true;
  }

  return false;
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/redux/helpers/localStorage.ts